import { Row, Col, Switch, Tag } from 'antd';

interface Props {
  label: string;
  value: boolean;
  staticValue: boolean;
  editMode: boolean;
  onChange: (value: boolean) => void;
}

export const GlobalPermissionRow = ({ label, value, staticValue, editMode, onChange }: Props) => {
  if (editMode) {
    return (
      <Row>
        <Col flex="0 0 240px">{label}:</Col>
        <Col>
          <Switch value={value} onChange={onChange} />
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col flex="0 0 240px">{label}:</Col>
      <Col>{staticValue ? <Tag color="green">Разрешено</Tag> : <Tag color="red">Запрещено</Tag>}</Col>
    </Row>
  );
};
